
import React, { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { BookOpen, MessageSquare } from 'lucide-react';

interface MainLayoutProps {
  children: ReactNode;
  isLoggedIn?: boolean;
  userRole?: string;
  onLogout?: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  isLoggedIn = false, 
  userRole = '',
  onLogout
}) => {
  const navigate = useNavigate();
  
  const getKnowledgeBaseUrl = () => {
    if (userRole === 'admin') {
      return '/admin/knowledge-base';
    } else if (userRole === 'superadmin') {
      return '/super-admin/knowledge-base';
    } else if (userRole === 'masterAdmin') {
      return '/master/knowledge-base';
    } else if (userRole === 'user') {
      return '/user/knowledge-base';
    }
    return '/knowledge-base';
  };
  
  const getSupportUrl = () => {
    if (userRole === 'admin') {
      return '/admin/support';
    } else if (userRole === 'superadmin') {
      return '/super-admin/support';
    } else if (userRole === 'masterAdmin') {
      return '/master/support';
    } else if (userRole === 'user') {
      return '/user/support';
    }
    return '/support';
  };
  
  const handleKnowledgeBaseClick = () => {
    navigate(getKnowledgeBaseUrl());
  };
  
  const handleSupportClick = () => {
    navigate(getSupportUrl());
  };
  
  return (
    <div className="min-h-screen flex flex-col bg-white font-sans">
      <Header 
        isLoggedIn={isLoggedIn} 
        userRole={userRole}
        onLogout={onLogout}
      />
      <main className="flex-grow">
        {isLoggedIn && (
          <div className="bg-gradient-to-r from-purple-100 to-blue-50 py-2 px-4 flex justify-center items-center space-x-6 shadow-sm">
            <Button 
              variant="link" 
              className="text-purple-700 hover:text-purple-900 font-medium transition-colors"
              onClick={handleKnowledgeBaseClick}
            >
              <BookOpen className="h-4 w-4 mr-2" />
              Knowledge Base - Learn how to use all features
            </Button>
            
            <Button 
              variant="link" 
              className="text-purple-700 hover:text-purple-900 font-medium transition-colors"
              onClick={handleSupportClick}
            >
              <MessageSquare className="h-4 w-4 mr-2" />
              Support Center
            </Button>
          </div>
        )}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
